import { FC, memo, useCallback } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

import { AUTH_ROUTES } from '@navigation/types';
import AuthLayout from '@components/layouts/AuthLayout';
import AuthTitle from '@components/auth/AuthTitle';
import SetUpProfile from '@components/form/SetUpProfile';

const Content = styled.div`
  min-width: 300px;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  margin-top: 36px;
`;

const Onboarding: FC = () => {
  const navigate = useNavigate();

  const onSuccess = useCallback(() => {
    navigate(AUTH_ROUTES.ONBOARDING_AVATAR_GENERATION, {
      replace: true,
      state: { fromOnboarding: true },
    });
  }, [navigate]);

  return (
    <AuthLayout>
      <Content>
        <AuthTitle title='Let’s set up your profile' />

        <SetUpProfile buttonText='Next' onSuccess={onSuccess} />
      </Content>
    </AuthLayout>
  );
};

export default memo(Onboarding);
